define('controllers/incentive/myIncentive-apply.ctrl',['app', 'mainCons'], function (app, mainCons) {

    app.controller('incentiveApplyCtrl', ['$q', '$filter', '$stateParams', '$location', '$state', 'auiDialog', '$scope', 'UserInfo', '$rootScope', 'OpenOther', 'OpenApp', 'modBussService', 'commonUtils', 'myIncentiveService',
        function ($q, $filter, $stateParams, $location, $state, auiDialog, $scope, UserInfo, $rootScope, OpenOther, OpenApp, modBussService, commonUtils, myIncentiveService) {
            var lang = 'zh_CN';
            var Model = $scope.Model = {
                acceptanceHisList: [],
                inspireTypeList: [],
                seletedInspireTypeList: [],
                acceptInfo: {},
                appList: [],
                functions: [],
                grandChilds: [],
                choosedFunctions: [],
                hmsKitIds: [],
                stateArr: [],
                choosedApplyType: [],
                showKeySelect: false,
                hmsKitDisable: false,
                hmsKitDirty: false,
                functionsDisable: false,
                otherDisable: false,
                selectDisable: false,
                hmsKitIdsTwo: [],
                hmsKitDisableTwo: false,
                hmsKitDirtyTwo: false,
                errorTip: {
                    isShowNullAppTipMsg: false
                }
            };
            Model.constant = {
                applyType: mainCons.incentiveConstant.applyType,
                serviceItems: mainCons.incentiveConstant.serviceItems,
                serviceOnlineStatus: mainCons.incentiveConstant.serviceOnlineStatus,
                state: mainCons.incentiveConstant.state,
                regexp: mainCons.servicesConstant.regexp,
                prodType: mainCons.appConstant.prodType
            };
            $scope.contains = AUI.BaseJSUtil.contains;
            $scope.appChange = appChange;
            $scope.selectFunction = selectFunction;
            $scope.checkBoxGrpValidator = checkBoxGrpValidator;
            $scope.checkDate = checkDate;
            $scope.selectKit = selectKit;
            $scope.selectKitTwo = selectKitTwo;
            $scope.isOnlyFirstApply = isOnlyFirstApply;
            $scope.doSubmit = doSubmit;
            $scope.cancel = cancel;
            $scope.isContainsValue = isContainsValue;
            $scope.accountCurrency = [];

            init();
            function init() {
                queryWhiteAppList();
                myIncentiveService.getKitList().then(function (kitList) {
                    Model.kitsList = kitList;
                    Model.kitsListTwo = kitList;
                });
                queryMerchantInfo();
            }

            function queryMerchantInfo() {
                // 获取商户信息币种
                modBussService.getBussinesInfo('00010001001', function (resp) {
                    if (resp.bankInfoEN) {
                        $scope.accountCurrency = resp.bankInfoEN.accountCurrencys ? resp.bankInfoEN.accountCurrencys.split(',') : [];
                        if (resp.bankInfoEN.currency) {
                            $scope.accountCurrency.push(resp.bankInfoEN.currency);
                        }
                    }
                    // 用户的银行信息
                    if (resp.bankInfoCN && resp.bankInfoCN.currency) {
                        $scope.accountCurrency.push(resp.bankInfoCN.currency);
                    }

                });
            }

            function isContainsValue(array, value) {
                var flag = false;
                if (array && array.length > 0) {
                    array.forEach(function (data) {
                        if (data.value == value) {
                            flag = true;
                        }
                    })
                }
                return flag;
            }

            function selectKit(kit) {
                if (Model.hmsKitDisable) {
                    return;
                }
                Model.hmsKitDirty = true;
                if (Model.hmsKitIds.indexOf(kit.kitID) >= 0) {
                    Model.hmsKitIds.splice(Model.hmsKitIds.indexOf(kit.kitID), 1);
                } else {
                    Model.hmsKitIds.push(kit.kitID);

                }
            }

            function selectKitTwo(kit) {
                if (Model.hmsKitDisableTwo) {
                    return;
                }
                Model.hmsKitDirtyTwo = true;
                if (Model.hmsKitIdsTwo.indexOf(kit.kitID) >= 0) {
                    Model.hmsKitIdsTwo.splice(Model.hmsKitIdsTwo.indexOf(kit.kitID), 1);
                } else {
                    Model.hmsKitIdsTwo.push(kit.kitID);

                }
            }

            function queryWhiteAppList() {
                myIncentiveService.queryInspireApp().then(function (data) {
                        if (data && data.resultCode == 0) {
                            var appList = data.inspireAppAbsList;
                            if (appList && appList.length > 0) {
                                Model.errorTip.isShowNullAppTipMsg = false;
                                var apps = [];
                                angular.forEach(appList, function (inspireApp) {
                                    var onlineFlag = false;
                                    var appSrv = inspireApp.appServiceInfo;
                                    if(inspireApp.subAppServiceInfo && appSrv){
                                        appSrv.subAppServiceInfo = inspireApp.subAppServiceInfo;
                                    }
                                    if (appSrv) {
                                        appSrv['inspireAppType'] = inspireApp.inspireAppType
                                        var serviceinfos = appSrv.serviceInfoList;
                                        if (serviceinfos && serviceinfos.length > 0) {
                                            for (var i = 0; i < serviceinfos.length; i++) {
                                                if (Model.constant.serviceOnlineStatus.indexOf(serviceinfos[i].serviceState) >= 0) {
                                                    onlineFlag = true;
                                                    break;
                                                }
                                            }
                                        }
                                        if (appSrv.subAppServiceInfo && appSrv.subAppServiceInfo.serviceInfoList && appSrv.subAppServiceInfo.serviceInfoList.length > 0 && !onlineFlag) {
                                            var subServiceinfos = appSrv.subAppServiceInfo.serviceInfoList;
                                            for (var i = 0; i < subServiceinfos.length; i++) {
                                                if (Model.constant.serviceOnlineStatus.indexOf(subServiceinfos[i].serviceState) >= 0) {
                                                    onlineFlag = true;
                                                    break;
                                                }
                                            }
                                        }
                                        if(inspireApp.productType && inspireApp.productType ==2 && Model.constant.serviceOnlineStatus.indexOf(inspireApp.appServiceInfo.state) >= 0){
                                            onlineFlag = true;
                                        }
                                        if (onlineFlag) {
                                            apps.push(appSrv);
                                        }
                                    }
                                });
                                angular.forEach(apps, function (app) {
                                    angular.forEach(appList, function (appl) {
                                        if (app.appInfo.appID == appl.appID && app.inspireAppType === appl.inspireAppType) {
                                            appl.appID = app.subAppServiceInfo?app.subAppServiceInfo.appInfo.appID:app.appInfo.appID;
                                            appl.appName = app.subAppServiceInfo?app.subAppServiceInfo.appInfo.appName:app.appInfo.appName;
                                            appl.appInfo = app.subAppServiceInfo?app.subAppServiceInfo.appInfo:app.appInfo;
                                            appl.prodType = app.subAppServiceInfo?app.subAppServiceInfo.appInfo.prodType:app.appInfo.prodType;
                                            if(app.subAppServiceInfo){
                                                appl.firstReleaseTime = app.subAppServiceInfo.appInfo.firstReleaseTime < app.appInfo.firstReleaseTime?app.subAppServiceInfo.appInfo.firstReleaseTime:app.appInfo.firstReleaseTime;
                                            }else{
                                                appl.firstReleaseTime = app.appInfo.firstReleaseTime;
                                            }
                                            Model.appList.push(appl);
                                        }
                                    });
                                });
                                myIncentiveService.deletQueryInspireApp();
                            } else {
                                Model.errorTip.isShowNullAppTipMsg = true;
                                Model.errorTip.errorNullAppTipMsg = '您申请激励项的应用未上架，暂时无法申请，请在应用上架后申请。'
                            }

                        } else {
                            auiDialog.fail("获取用户放通名单数据失败。");
                        }

                }).catch(function (data) {
                    if (data && data.NSP_STATUS) {
                        auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                    } else if (data && data.resultCode) {
                        auiDialog.fail("获取用户放通名单数据失败。");
                    }
                });
            }

            function appChange(value) {
                Model.inspireTypeList = [];
                Model.inspireAppKey = value.inspireAppKey;
                Model.appID = value.appServiceInfo.appInfo.appID;
                Model.firstReleaseTime = value.appServiceInfo.appInfo.firstReleaseTime;
                Model.currency = value.currency;
                Model.parentTypeName = "";
                Model.showKeySelect = false;
                Model.parentType = "";
                Model.childTypeName = "";
                Model.grandChildTypeName = "";
                Model.grandChildType = "";
                Model.grandChild = "";
                Model.choosedGrandChildType = "";
                Model.grandChilds = [];
                Model.choosedFunctions = [];
                Model.seletedInspireTypeList = [];
                Model.grandChild.functions = [];
                Model.stateArr = [];
                Model.choosedApplyType = [];
                Model.hmsKitDisable = false;
                Model.hmsKitDisableTwo = false;
                Model.functionsDisable = false;
                Model.selectDisable = false;
                Model.otherDisable = false;
                Model.googleAppName = "";
                Model.googlePkgName = "";
                Model.googlePkgVsn = "";
                Model.keyFeatures = "";
                Model.hmsKitIds = [];
                Model.hmsKitIdsTwo = [];
                Model.productType = value.productType;
                applyHisAcceptance(value);
                if(value.appInfo && value.appInfo.parentType){
                    getAppFunctionList(value.appInfo);
                }else if(value.appServiceInfo && value.appServiceInfo.parentType){
                    getAppFunctionList(value.appServiceInfo);
                }
            }


            function getAppFunctionList(appInfo) {
                var defer = $q.defer();
                var childType = appInfo.childType;
                Model.parentTypeName = (appInfo.parentType == 2 ? "游戏" : "应用");
                Model.parentType = appInfo.parentType;
                if (childType && appInfo.parentType != 2) {
                    var grandChildType = appInfo.grandChildType;
                    Model.grandChildType = appInfo.grandChildType;
                    var params = {
                        req: {
                            lang: lang,
                            childType: childType
                        }
                    };
                    OpenOther.queryAppFunctionList(params).then(function (resp) {
                        if (resp.appFunctionDatas && resp.appFunctionDatas.length > 0) {
                            var appFunctionDatas = resp.appFunctionDatas[0];
                            Model.childTypeName = appFunctionDatas.childTypeName;
                            if (appFunctionDatas.grandChildInfos && appFunctionDatas.grandChildInfos.length > 0) {
                                Model.grandChild = appFunctionDatas.grandChildInfos[0];
                                if (!Model.choosedGrandChildType) {
                                    Model.selectDisable = false;
                                    Model.functionsDisable = false;
                                } else {
                                    Model.selectDisable = true;
                                }
                                if (Model.stateArr.indexOf(3) != -1 && Model.choosedApplyType.indexOf(2) == -1) {
                                    Model.selectDisable = false;
                                }
                                appFunctionDatas.grandChildInfos.forEach(function (grand) {
                                    Model.grandChilds.push(grand);
                                    if (grand.grandChildType == grandChildType) {
                                        Model.grandChild = grand;
                                        Model.grandChildTypeName = grand.grandChildTypeName;
                                        Model.showKeySelect = true;
                                    }
                                    if (grand.grandChildType == Model.choosedGrandChildType) {
                                        Model.grandChild = grand;
                                    }
                                })
                            }
                        }
                    }).catch(function (resp) {
                        defer.reject();
                        if (resp && resp.NSP_STATUS) {
                            auiDialog.failSystemError($filter('auiErrorCode')(resp.NSP_STATUS));
                        } else if (resp && resp.resultCode) {
                            auiDialog.fail("获取应用类别信息失败。");
                        }
                    });
                }
                return defer.promise;
            }

            function selectFunction(fun) {
                if (Model.functionsDisable) {
                    return;
                }
                Model.choosedFunctionsDirty = true;
                if (Model.choosedFunctions.indexOf(fun.functionId) >= 0) {
                    Model.choosedFunctions.splice(Model.choosedFunctions.indexOf(fun.functionId), 1);
                } else {
                    Model.choosedFunctions.push(fun.functionId);
                }
            }

            function getOtherPrmtItems(appObj) {
                if (appObj.otherPrmtItems && appObj.otherPrmtItems.length > 0) {
                    appObj.otherPrmtItems.forEach(function (item) {
                        var accept = {
                            label: item['prmtLang'].prmtName,
                            value: item['prmtId'],
                            checked: false,
                            applyType: ""
                        };
                        Model.inspireTypeList.push(accept);
                        setInspireState(accept, appObj);

                    });
                }
            }

            function applyHisAcceptance(appObj) {
                var objAppID = appObj.appServiceInfo.appInfo.appID;
                OpenOther.getAcceptanceList({
                    req: {
                        user: appObj['userID'],
                        appID: objAppID,
                        maxReqCount: 100,
                        inspireAppType: appObj['inspireAppType']
                    }
                }).then(function (data) {
                    if (data && data.resultCode == 0) {
                        Model.acceptanceHisList = data.acceptanceList;
                        if (Model.acceptanceHisList && Model.acceptanceHisList.length > 0) {
                            for (var i = 0; i < Model.acceptanceHisList.length; i++) {
                                if (Model.acceptanceHisList[i].nextSubTime) {
                                    appObj.nextSubTime = Model.acceptanceHisList[i].nextSubTime;
                                }
                            }
                        }
                        getOtherPrmtItems(appObj);
                        if (Model.acceptanceHisList && Model.acceptanceHisList.length > 0) {
                            var stateArr = [];
                            var acceptanceArr = [];
                            for (var i = 0; i < Model.acceptanceHisList.length; i++) {
                                if (appObj.appID == Model.acceptanceHisList[i].subAppID || Model.acceptanceHisList[i].appID) {
                                    acceptanceArr.push(Model.acceptanceHisList[i]);
                                    for (var j = 0; j < acceptanceArr.length; j++) {
                                        Model.googleAppName = acceptanceArr[0].googleAppName;
                                        Model.googlePkgName = acceptanceArr[0].googlePkgName;
                                        Model.googlePkgVsn = acceptanceArr[0].googlePkgVsn;
                                        Model.keyFeatures = acceptanceArr[0].keyFeatures;
                                        if (acceptanceArr[0].grandChildType) {
                                            Model.choosedGrandChildType = acceptanceArr[0].grandChildType;
                                        }
                                        if (acceptanceArr[0].functionIdList) {
                                            Model.choosedFunctions = Model.choosedFunctions.concat(acceptanceArr[0].functionIdList.split(',').map(function (numberString) {
                                                return parseInt(numberString);
                                            }));
                                            Model.choosedFunctions = AUI.BaseJSUtil.unique(Model.choosedFunctions);
                                        }
                                    }

                                    stateArr.push(Model.acceptanceHisList[i].state);
                                    Model.choosedApplyType.push(Model.acceptanceHisList[i].applyType);
                                    Model.stateArr = stateArr;
                                }
                                Model.acceptanceHisList.forEach(function (acceptance) {
                                    if(acceptance.nextSubTime){
                                        appObj.nextSubTime = acceptance.nextSubTime;
                                    }
                                })
                            }
                            if (stateArr.indexOf(1) == -1 && stateArr.indexOf(2) == -1) {
                                Model.functionsDisable = false;
                                Model.otherDisable = false;
                            } else {
                                Model.functionsDisable = true;
                                Model.otherDisable = true;
                            }
                        }
                        setApplyTempShow(appObj);
                    } else {
                        auiDialog.fail("获取申请记录失败。");
                    }
                }).catch(function (data) {
                    auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                });
            }

            function setApplyTempShow(appObj) {
                // 整个申请激励类型是否显示
                if (appObj['promoteItemList']) {
                    var promoteItemList = appObj.promoteItemList.split(',');
                    var defer = $q.defer();
                    var params = {
                        req: {
                            prmtIdList: promoteItemList,
                            lang: lang
                        }
                    };
                    OpenOther.getPromotionItemList(params).then(function (resp) {
                        if (resp.prmtItemList && resp.prmtItemList.length > 0) {
                            resp.prmtItemList.forEach(function (prmtItem) {
                                var item = {
                                    label: prmtItem.prmtLang.prmtName,
                                    value: prmtItem.prmtId,
                                    checked: false,
                                    applyType: ''
                                };
                                Model.inspireTypeList.push(item);
                                setInspireState(item, appObj);
                            })
                        }
                    }).catch(function (resp) {
                        auiDialog.failSystemError($filter('auiErrorCode')(resp.NSP_STATUS));
                        defer.reject();
                    });
                    return defer.promise;
                }
                // 其他激励类型
            }

            function getacceptanceListByType(acceptanceList, type) {
                var list = [];
                for (var i = 0; i < acceptanceList.length; i++) {
                    var acceptance = acceptanceList[i];
                    var promoteItem = acceptance['promoteItem'];
                    if (promoteItem == type) {
                        list.push(acceptance);
                    }
                }
                return list;
            }

            // 是否只是首次申请： true是 false否
            function isOnlyFirstApply(acceptanceList, type) {
                var isOnlyFirst = true;
                for (var i = 0; i < acceptanceList.length; i++) {
                    var acceptance = acceptanceList[i];
                    var applyType = acceptance['applyType'];
                    var promoteItem = acceptance['promoteItem'];
                    if (applyType == 2 && promoteItem == type) {
                        isOnlyFirst = false;
                        break;
                    }
                }
                return isOnlyFirst;
            }

            // 判断该激励类型是否可以操作
            function setInspireState(item, appObj) {
                var type = item['value'];
                var acceptScene = -1;
                if(appObj.preliminaryAcptTime){
                    var isOverPreliminaryAcptTime = $filter('auiDateFormat')(appObj.preliminaryAcptTime, '+0000').getTime() < new Date().getTime();
                    var preliminaryAcptTime = $filter('date')($filter('auiDateFormat')($filter('date')(appObj.preliminaryAcptTime, "yyyy-MM-dd"), '+0000'),'yyyy-MM-dd HH:mm:ss');//初验截止日期
                }
                if(appObj.finalAcptTime){
                    var isOverFinalAcptTime = $filter('auiDateFormat')(appObj.finalAcptTime, '+0000').getTime() < new Date().getTime();
                    var finalAcptTime = $filter('date')($filter('auiDateFormat')($filter('date')(appObj.finalAcptTime, "yyyy-MM-dd"), '+0000'),'yyyy-MM-dd HH:mm:ss');//终验截止日期
                }
                if (Model.acceptanceHisList && Model.acceptanceHisList.length > 0) {
                    // 去除当前类型下的白名单
                    var acceptanceListForType = getacceptanceListByType(Model.acceptanceHisList, type);
                    // 是否是首次申请
                    var isFirstApply = isOnlyFirstApply(acceptanceListForType, type);
                    if (acceptanceListForType && acceptanceListForType.length > 0) {
                        // 循环判断
                        for (var i = 0; i < acceptanceListForType.length; i++) {
                            var acceptance = acceptanceListForType[i];
                            // 1.申请中2.通过 3.不通过
                            var state = acceptance['state'];
                            // 激励类型
                            var promoteItem = acceptance['promoteItem'];
                            if (isFirstApply && state == 3 && promoteItem == type) {
                                acceptScene = 0;
                                // 首次申请 已驳回 状态放行需校验激励性首次上架时间
                                var promoteItemList = appObj.promoteItemList;
                                var releaseTime = 0;
                                if (promoteItemList && promoteItemList.indexOf(type) == -1) {
                                    appObj.otherPrmtItems.forEach(function(otherPrmtItem) {
                                        if (otherPrmtItem.prmtId == type) {
                                        releaseTime = (otherPrmtItem.releaseTime != undefined?otherPrmtItem.releaseTime:appObj.releaseTime?appObj.releaseTime:0);
                                    }
                                });
                                } else {
                                    releaseTime = (appObj.releaseTime != undefined?appObj.releaseTime:appObj.releaseTime?appObj.releaseTime:0);
                                }
                                var firstRelTime = appObj['firstReleaseTime'];
                                if (firstRelTime) {
                                    if (releaseTime == 0 || !checkDate($filter('date')(firstRelTime, 'yyyy-MM-dd'), $filter('date')(($filter('auiDateFormat')($filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'), new Date().toString().split(' ')[5].split('GMT')[1], '+0000')), 'yyyy-MM-dd'), releaseTime)) {
                                        if(isOverPreliminaryAcptTime){//上架时长够了，但是初验时间已到
                                            item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                            item['disabled'] = true;
                                        }
                                    } else {
                                        if(isOverPreliminaryAcptTime){//上架时间未到，初验截止日期已到，提示语要变
                                            item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                            item['disabled'] = true;
                                        }else{
                                            item['title'] = "该产品不满足上架时长" + releaseTime + "个月的要求，无法提交。";
                                            item['disabled'] = true;
                                        }
                                    }
                                }
                            } else if (isFirstApply && state == 2 && promoteItem == type) {
                                // 首次申请 已通过
                                acceptScene = 2;
                                var promoteItemList = appObj.promoteItemList;
                                var acptTimes = 2;
                                var acptInterval = 3;
                                if (promoteItemList.indexOf(type) == -1) {
                                    appObj.otherPrmtItems.forEach(function (otherPrmtItem) {
                                        if (otherPrmtItem.prmtId == type) {
                                            acptTimes = otherPrmtItem.acptTimes != undefined ? otherPrmtItem.acptTimes : ((appObj.acptTimes || appObj.acptTimes === 0) ? appObj.acptTimes : acptTimes);
                                            acptInterval = otherPrmtItem.acptInterval != undefined ? otherPrmtItem.acptInterval : ((appObj.acptInterval || appObj.acptInterval === 0) ? appObj.acptInterval : acptInterval);
                                        }
                                    });
                                } else {
                                    acptTimes = appObj.acptTimes != undefined ? appObj.acptTimes : 2;
                                    acptInterval = appObj.acptInterval != undefined ? appObj.acptInterval : 3;
                                }

                                if (acptTimes == 1) {
                                    item['title'] = '您首次' + item['label'] + '的激励金验收首次申请已通过，不允许进行二次申请。';
                                    item['disabled'] = true;
                                }
                                // 判断距离当前时间是否超过3个月，如果超过，可以进行二次申请
                                else if (acptInterval == 0 || !checkDate($filter('date')(acceptance['submitTime'], 'yyyy-MM-dd'), $filter('date')(($filter('auiDateFormat')($filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'), new Date().toString().split(' ')[5].split('GMT')[1], '+0000')), 'yyyy-MM-dd'), acptInterval)) {
                                    if(isOverFinalAcptTime){//如果达到了可以二次验收的要求，但是终验时间到了
                                        item['title'] = "已过终验截至时间（"+ finalAcptTime +"），不允许申请验收";
                                        item['disabled'] = true;
                                    }

                                } else {
                                    if(isOverFinalAcptTime){//如果未超过验收间隔,且终验时间已到，提示的是终验时间
                                        item['title'] = "已过终验截至时间（"+ finalAcptTime +"），不允许申请验收";
                                        item['disabled'] = true;
                                    }else{
                                        // 如果未超过验收间隔，则告诉开发者还需要多少天可以进行二次申请
                                        var diffDays = commonUtils.getDaysBetween(new Date(), commonUtils.addMonth($filter('date')($filter('auiDateFormat')(acceptance['submitTime'], '+0000'), 'yyyy-MM-dd'), acptInterval));
                                        if(acceptance['nextSubTime']){
                                            var localTime = $filter('date')($filter('auiDateFormat')($filter('date')(acceptance['nextSubTime'], "yyyy-MM-dd"), '+0000'),'yyyy-MM-dd HH:mm:ss');
                                            item['title'] = '您二次' + item['label'] + '的激励金未到验收申请时间'+'（' + localTime + '）' +'，请您在' + diffDays + '天以后提交。';
                                        }else{
                                            item['title'] = '您二次' + item['label'] + '的激励金未到验收申请时间，请您在' + diffDays + '天以后提交。';
                                        }
                                        //'您首次' + item['label'] + '的激励金验收申请距今未到' + acptInterval + '个月，不允许进行二次申请。';
                                        item['disabled'] = true;
                                    }

                                }
                            } else if (isFirstApply && (state == 1||state == 4||state == 5) && promoteItem == type) {
                                // 首次申请 在申请中
                                item['title'] = '您提交的' + item['label'] + '，激励金验收申请在审核中，不允许重复申请。';
                                item['disabled'] = true;
                            } else if (!isFirstApply && state == 2 && promoteItem == type) {
                                // 二次申请 已通过
                                item['title'] = '您已进行过' + item['label'] + '的激励金二次申请，不允许重复申请。';
                                item['disabled'] = true;
                            } else if (!isFirstApply && state == 3 && promoteItem == type) {
                                acceptScene = 4;
                                if(isOverFinalAcptTime){//二次申请驳回，终验截止时间已到
                                    item['title'] = "已过终验截至时间（"+ finalAcptTime +"），不允许申请验收";
                                    item['disabled'] = true;
                                }
                                // 二次申请 已驳回，可以再次二次申请
                            } else if (!isFirstApply && state == 1 && promoteItem == type) {
                                //  二次申请 在申请中
                                item['title'] = '您提交的' + item['label'] + '，激励金验收二次申请在审核中，不允许重复申请。';
                                item['disabled'] = true;
                            }
                            break;
                        }
                    }
                    var promoteItemList = appObj.promoteItemList;
                    var releaseTime = 0;
                    if (promoteItemList.indexOf(type) == -1) {
                        appObj.otherPrmtItems.forEach(function(otherPrmtItem) {
                            if (otherPrmtItem.prmtId == type) {
                                releaseTime = otherPrmtItem.releaseTime != undefined?otherPrmtItem.releaseTime:appObj.releaseTime?appObj.releaseTime:0;
                            }
                        });
                    } else {
                        releaseTime = appObj.releaseTime != undefined?appObj.releaseTime:appObj.releaseTime?appObj.releaseTime:0;
                    }
                    var firstRelTime = appObj['firstReleaseTime'];
                    if (firstRelTime) {
                        if (releaseTime == 0 || !checkDate($filter('date')(firstRelTime, 'yyyy-MM-dd'), $filter('date')(($filter('auiDateFormat')($filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'), new Date().toString().split(' ')[5].split('GMT')[1], '+0000')), 'yyyy-MM-dd'), releaseTime)) {
                            if(!Object.prototype.hasOwnProperty.call(item,"disabled") || !item['disabled']){// 按照之前逻辑满足了申请验收的情况下,校验 disabled属性为false,放行； 为true，只校验初验、终验
                                if(acceptScene == 0){
                                    if(isOverPreliminaryAcptTime){//上架时长够了，但是初验时间已到
                                        item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                        item['disabled'] = true;
                                    }
                                }else if(acceptScene == 2 || acceptScene == 4){
                                    if(isOverFinalAcptTime){//如果达到了可以二次验收的要求，但是终验时间到了
                                        item['title'] = "已过终验截至时间（"+ finalAcptTime +"），不允许申请验收";
                                        item['disabled'] = true;
                                    }
                                }else{
                                    if(isOverPreliminaryAcptTime){//上架时长够了，但是初验时间已到
                                        item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                        item['disabled'] = true;
                                    }
                                }

                            }

                        } else {
                            if(isOverPreliminaryAcptTime){//上架时长够了，但是初验时间已到
                                item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                item['disabled'] = true;
                            }else{
                                item['disabled'] = true;
                                item['title'] = "该产品不满足上架时长" + releaseTime + "个月的要求，无法提交。";
                            }

                        }
                    }else{
                        if(!Object.prototype.hasOwnProperty.call(item,"disabled") || !item['disabled']){// 按照之前逻辑满足了申请验收的情况下,校验 disabled属性为false,放行； 为true，只校验初验、终验
                            if(acceptScene == 0){
                                if(isOverPreliminaryAcptTime){//上架时长够了，但是初验时间已到
                                    item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                    item['disabled'] = true;
                                }
                            }else if(acceptScene == 2 || acceptScene == 4){
                                if(isOverFinalAcptTime){//如果达到了可以二次验收的要求，但是终验时间到了
                                    item['title'] = "已过终验截至时间（"+ finalAcptTime +"），不允许申请验收";
                                    item['disabled'] = true;
                                }
                            }else{
                                if(isOverPreliminaryAcptTime){//上架时长够了，但是初验时间已到
                                    item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                    item['disabled'] = true;
                                }
                            }
                        }
                    }
                }else {
                    // 首次申请 已通过
                    var appObj = null;
                    Model.appList.forEach(function (appInfoItem) {
                        if (Model.appID == appInfoItem.appServiceInfo.appInfo.appID) {
                            appObj = appInfoItem;
                        }
                    });
                    var promoteItemList = appObj.promoteItemList;
                    var releaseTime = 0;
                    if (promoteItemList.indexOf(type) == -1) {
                        appObj.otherPrmtItems.forEach(
                            function (otherPrmtItem) {
                                if (otherPrmtItem.prmtId == type) {
                                    releaseTime = otherPrmtItem.releaseTime != undefined ? otherPrmtItem.releaseTime : appObj.releaseTime ? appObj.releaseTime : 0;
                                }
                            }
                        );
                    } else {
                        releaseTime = appObj.releaseTime != undefined ? appObj.releaseTime : appObj.releaseTime ? appObj.releaseTime : 0;
                    }
                    var firstRelTime = '';
                    if(appObj.subAppServiceInfo){
                        firstRelTime = appObj.subAppServiceInfo.appInfo.firstReleaseTime < appObj.appServiceInfo.appInfo.firstReleaseTime?appObj.subAppServiceInfo.appInfo.firstReleaseTime:appObj.appServiceInfo.appInfo.firstReleaseTime;
                    }else{
                        firstRelTime = appObj.appInfo['firstReleaseTime'];
                    }
                    if (firstRelTime) {
                        if (releaseTime == 0 || !checkDate($filter('date')(firstRelTime, 'yyyy-MM-dd'), $filter('date')(($filter('auiDateFormat')($filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'), new Date().toString().split(' ')[5].split('GMT')[1], '+0000')), 'yyyy-MM-dd'), releaseTime)) {
                            if(!Object.prototype.hasOwnProperty.call(item,"disabled") || !item['disabled']){// 按照之前逻辑满足了申请验收的情况下,校验 disabled属性为false,放行； 为true，只校验初验、终验
                                if(acceptScene == 0){
                                    if(isOverPreliminaryAcptTime){//上架时长够了，但是初验时间已到
                                        item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                        item['disabled'] = true;
                                    }
                                }else if(acceptScene == 2 || acceptScene == 4){
                                    if(isOverFinalAcptTime){//如果达到了可以二次验收的要求，但是终验时间到了
                                        item['title'] = "已过终验截至时间（"+ finalAcptTime +"），不允许申请验收";
                                        item['disabled'] = true;
                                    }
                                }else{
                                    if(isOverPreliminaryAcptTime){//上架时长够了，但是初验时间已到
                                        item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                        item['disabled'] = true;
                                    }
                                }
                            }
                        } else {
                            if(isOverPreliminaryAcptTime){
                                item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                item['disabled'] = true;
                            }else{
                                item['disabled'] = true;
                                item['title'] = "该产品不满足上架时长" + releaseTime + "个月的要求，无法提交";
                            }
                        }
                    }else{
                        if(!Object.prototype.hasOwnProperty.call(item,"disabled") || !item['disabled']){// 按照之前逻辑满足了申请验收的情况下,校验 disabled属性为false,放行； 为true，只校验初验、终验
                            if(acceptScene == 0){
                                if(isOverPreliminaryAcptTime){//上架时长够了，但是初验时间已到
                                    item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                    item['disabled'] = true;
                                }
                            }else if(acceptScene == 2 || acceptScene == 4){
                                if(isOverFinalAcptTime){//如果达到了可以二次验收的要求，但是终验时间到了
                                    item['title'] = "已过终验截至时间（"+ finalAcptTime +"），不允许申请验收";
                                    item['disabled'] = true;
                                }
                            }else{
                                if(isOverPreliminaryAcptTime){//上架时长够了，但是初验时间已到
                                    item['title'] = "已过初验截至时间（"+ preliminaryAcptTime +"），不允许申请验收";
                                    item['disabled'] = true;
                                }
                            }
                        }
                    }
                }
            }


            // 根据选择的模板，设置申请阶段
            function checkAndSetApplyType(items) {
                var type = items.value;
                if (Model.acceptanceHisList && Model.acceptanceHisList.length > 0) {
                    // 去除当前类型下的白名单
                    var acceptanceListForType = getacceptanceListByType(Model.acceptanceHisList, type);

                    // 是否是首次申请
                    var isFirstApply = isOnlyFirstApply(acceptanceListForType, type);

                    if (acceptanceListForType && acceptanceListForType.length > 0) {
                        // 循环判断
                        for (var i = 0; i < acceptanceListForType.length; i++) {
                            var acceptance = acceptanceListForType[i];
                            if (acceptance.hmsKits) {
                                if (type == 3) {
                                    Model.hmsKitIds = Model.hmsKitIds.concat(acceptance.hmsKits.split(','));
                                    Model.hmsKitIds = AUI.BaseJSUtil.unique(Model.hmsKitIds);
                                }
                                if (type == 4) {
                                    Model.hmsKitIdsTwo = Model.hmsKitIdsTwo.concat(acceptance.hmsKits.split(','));
                                    Model.hmsKitIdsTwo = AUI.BaseJSUtil.unique(Model.hmsKitIdsTwo);
                                }
                            }
                            // 1.申请中2.通过 3.不通过
                            var state = acceptance['state'];
                            // 激励类型
                            var promoteItem = acceptance['promoteItem'];

                            if (isFirstApply && state == 3 && promoteItem == type) {
                                // 首次申请 已驳回 状态
                                items.applyType = 1;

                            } else if (isFirstApply && state == 2 && promoteItem == type) {
                                // 首次申请 已通过
                                var appObj = null;
                                Model.appList.forEach(function (appInfo) {
                                    if (Model.appID == appInfo.appServiceInfo.appInfo.appID) {
                                        appObj = appInfo;
                                    }
                                });
                                var promoteItemList = appObj.promoteItemList;
                                var acptTimes = 2;
                                var acptInterval = 3;
                                if (promoteItemList && promoteItemList.indexOf(type) == -1) {
                                    appObj.otherPrmtItems.forEach(function (otherPrmtItem) {
                                        if (otherPrmtItem.prmtId == type) {
                                            acptTimes = (otherPrmtItem.acptTimes != undefined ? otherPrmtItem.acptTimes : ((appObj.acptTimes || appObj.acptTimes === 0) ? appObj.acptTimes : acptTimes));
                                            acptInterval = (otherPrmtItem.acptInterval != undefined ? otherPrmtItem.acptInterval : ((appObj.acptInterval || appObj.acptInterval === 0) ? appObj.acptInterval : acptInterval));
                                        }
                                    });
                                } else {
                                    acptTimes = (appObj.acptTimes != undefined) ? appObj.acptTimes : 2;
                                    acptInterval = (appObj.acptInterval != undefined) ? appObj.acptInterval : 3;
                                }
                                // 判断距离当前时间是否超过3个月，如果超过，可以进行二次申请
                                if (acptInterval == 0) {
                                    items.applyType = 2;
                                }
                                else if (!checkDate($filter('date')(acceptance['submitTime'], 'yyyy-MM-dd'), $filter('date')(($filter('auiDateFormat')($filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'), new Date().toString().split(' ')[5].split('GMT')[1], '+0000')), 'yyyy-MM-dd'), acptInterval)) {
                                    items.applyType = 2;

                                } else {
                                    // 如果未超过验收间隔，则告诉开发者还需要多少天可以进行二次申请
                                    var diffDays = commonUtils.getDaysBetween(new Date(), commonUtils.addMonth($filter('date')($filter('auiDateFormat')(acceptance['submitTime'], '+0000'), 'yyyy-MM-dd'), acptInterval));
                                    item['title'] = '您二次激励金未到验收申请时间，请您在' + diffDays + '天以后提交。';
                                    //'您首次激励金验收申请距今未到'+acptInterval+'个月，不允许进行二次申请。';
                                    // 如果未超过3个月
                                }
                            } else if (isFirstApply && state == 1 && promoteItem == type) {
                                items.title = '您提交的激励金验收申请在审核中，请勿重复申请。';
                                // 首次申请 在申请中
                            } else if (!isFirstApply && state == 2 && promoteItem == type) {
                                items.title = '您已进行过激励金二次申请，请勿重复申请。';
                                // 二次申请 已通过
                            } else if (!isFirstApply && state == 3 && promoteItem == type) {
                                // 二次申请 已驳回，可以再次二次申请
                                items.applyType = 2;
                            } else if (!isFirstApply && state == 1 && promoteItem == type) {
                                //  二次申请 在申请中
                                items.title = '您提交的激励金验收申请在审核中，请勿重复申请。'
                            } else {
                                items.applyType = 1;
                            }
                            break;
                        }

                    } else {
                        items.applyType = 1;

                    }

                } else {
                    // 首次申请 已通过
                    var appObj = null;
                    var releaseTime = 0;
                    Model.appList.forEach(function (appInfoItem) {
                        if (Model.appID == appInfoItem.appServiceInfo.appInfo.appID) {
                            appObj = appInfoItem;
                        }
                    });
                    var promoteItemList = appObj.promoteItemList;
                    var firstRelTime = '';
                    if(appObj.subAppServiceInfo){
                        firstRelTime = appObj.subAppServiceInfo.appInfo.firstReleaseTime < appObj.appServiceInfo.appInfo.firstReleaseTime?appObj.subAppServiceInfo.appInfo.firstReleaseTime:appObj.appServiceInfo.appInfo.firstReleaseTime;
                    }else{
                        firstRelTime = appObj.appInfo['firstReleaseTime'];
                    }
                    if (promoteItemList.indexOf(type) == -1) {
                        appObj.otherPrmtItems.forEach(
                            function (otherPrmtItem) {
                                if (otherPrmtItem.prmtId == type) {
                                    releaseTime = (otherPrmtItem.releaseTime != undefined) ? otherPrmtItem.releaseTime : appObj.releaseTime ? appObj.releaseTime : 0;
                                }
                            }
                        );
                    } else {
                        releaseTime = (appObj.releaseTime != undefined) ? appObj.releaseTime : appObj.releaseTime ? appObj.releaseTime : 0;
                    }

                    if (firstRelTime) {
                        // |auiDateFormat:"+0000"| date:'y-MM-dd HH:mm:ss'
                        if (releaseTime == 0 || !checkDate($filter('date')(firstRelTime, 'yyyy-MM-dd'), $filter('date')(($filter('auiDateFormat')($filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'), new Date().toString().split(' ')[5].split('GMT')[1], '+0000')), 'yyyy-MM-dd'), releaseTime)) {
                            items.applyType = 1;
                        } else {
                            items['disabled'] = true;
                            items['title'] = "该产品不满足上架时长" + releaseTime + "个月的要求，无法提交";
                        }
                    } else {
                        items.applyType = 1;
                    }
                }
                if (!items.title) {
                    Model.seletedInspireTypeList.push(items);
                }
                //value 为3的激励类型的置灰 且为二次验收
                if (items.value == 3 && items.applyType == 2) {
                    Model.hmsKitDisable = true;
                }
                //value 为4的激励类型的置灰 且为二次验收
                if (items.value == 4 && items.applyType == 2) {
                    Model.hmsKitDisableTwo = true;
                }
            }

            function checkBoxGrpValidator(items, flag) {
                if (flag) return;
                Model.seletedInspireTypeDirty = true;
                if (Model.seletedInspireTypeList.indexOf(items) >= 0) {
                    Model.seletedInspireTypeList.splice(Model.seletedInspireTypeList.indexOf(items), 1);
                    items.applyType = "";
                } else {
                    checkAndSetApplyType(items);
                }
            }


            function checkDate(startTime, endTime, num) {
                var startTimeArr = startTime.split('-');
                var endTimeArr = endTime.split('-');
                startTimeArr[2] = startTimeArr[2].split(' ')[0];
                //判断时间跨度是否大于指定月数
                startTimeArr = startTimeArr.map(Number);
                endTimeArr = endTimeArr.map(Number);
                var flag = true;
                if (startTimeArr[0] == endTimeArr[0]) {//同年
                    if (endTimeArr[1] - startTimeArr[1] > num) { //月间隔超过3个月
                        flag = false;
                    } else if (endTimeArr[1] - startTimeArr[1] == num) { //月相隔3个月，比较日
                        if (endTimeArr[2] > startTimeArr[2]) { //结束日期的日大于开始日期的日
                            flag = false;
                        }
                    }
                } else { //不同年
                    if (endTimeArr[0] - startTimeArr[0] > 1) {
                        flag = false;
                    } else if (endTimeArr[0] - startTimeArr[0] == 1) {
                        if (startTimeArr[1] < 13 - num) { //开始年的月份小于10时，不需要跨年
                            flag = false;
                        } else if (startTimeArr[1] + num - endTimeArr[1] < 12) { //月相隔大于3个月
                            flag = false;
                        } else if (startTimeArr[1] + num - endTimeArr[1] == 12) { //月相隔3个月，比较日
                            if (endTimeArr[2] > startTimeArr[2]) { //结束日期的日大于开始日期的日
                                flag = false;
                            }
                        }
                    }
                }
                if (!flag) {
                    return false;
                }
                return true;
            }

            //验证包名
            $scope.validPackageName = (function () {
                return {
                    test: function (value) {
                        return (new RegExp(Model.constant.regexp.packageName)).test(value);
                    }
                }
            })();
            function doSubmit() {
                if (!($scope.applyForm.$valid && Model.seletedInspireTypeList.length > 0
                    && ((!Model.childTypeName) || (Model.childTypeName && Model.choosedFunctions && Model.choosedFunctions.length > 0))
                    && (!isContainsValue(Model.seletedInspireTypeList, 3) || (isContainsValue(Model.seletedInspireTypeList, 3) && Model.hmsKitIds.length > 0))
                    && (!isContainsValue(Model.seletedInspireTypeList, 4) || (isContainsValue(Model.seletedInspireTypeList, 4) && Model.hmsKitIdsTwo.length > 0)))) {
                    return;
                }
                var acceptance = {};
                var submitAcceptanceList = [];
                var subTime = new Date();

                Model.seletedInspireTypeList.forEach(function (item) {
                    acceptance = {};
                    acceptance.promoteItem = item.value;
                    acceptance.googleAppName = Model.googleAppName;
                    acceptance.googlePkgName = Model.googlePkgName;
                    acceptance.googlePkgVsn = Model.googlePkgVsn;
                    acceptance.submitTime = subTime;
                    if (Model.grandChild) {
                        acceptance.grandChildType = Model.grandChild.grandChildType;
                        acceptance.functionIdList = Model.choosedFunctions.join(',');
                    }
                    if (Model.keyFeatures) {
                        acceptance.keyFeatures = Model.keyFeatures;
                    }
                    if (item.value == 3) {
                        acceptance.hmsKits = Model.hmsKitIds.join(',');
                    } else if (item.value == 4) {
                        acceptance.hmsKits = Model.hmsKitIdsTwo.join(',');
                    } else {
                        acceptance.hmsKits = "";
                    }
                    acceptance.appID = Model.appID;
                    acceptance.applyType = item.applyType;
                    acceptance.inspireAppKey = Model.inspireAppKey;
                    submitAcceptanceList.push(acceptance);
                });
                if (Model.currency) {
                    var merUrl = sysUrlCfg.user.memberCenterUrl + '#/mysetting/modBussnessInfo';
                    if ($scope.accountCurrency.indexOf(Model.currency) == -1) {
                        auiDialog.confirm('提醒', '您当前维护的银行账号不支持“' + Model.currency + '”币种，为避免因此造成的付款失败或延误，请您及时更新您的<a class="text-link" target="_blank" href="' + merUrl + '">银行账户</a>可支持币种信息。', function () {
                            applyForAcceptance(submitAcceptanceList);
                        });
                    } else {
                        applyForAcceptance(submitAcceptanceList);
                    }
                } else {
                    applyForAcceptance(submitAcceptanceList);
                }
            }

            function applyForAcceptance(submitAcceptanceList) {
                OpenOther.applyForAcceptance({
                    req: {
                        acceptanceList: submitAcceptanceList
                    }
                }).then(function (data) {
                    if (data && data.resultCode == 0) {
                        cancel();
                    } else {
                        auiDialog.fail("提交失败。");
                    }
                }).catch(function (data) {
                    if (data && data.NSP_STATUS) {
                        auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                    } else if (data && data.resultCode) {
                        auiDialog.fail("提交失败。。");
                    }
                });
            }

            function cancel() {
                $state.go('myIncentive');
            }

        }]);
});

